import { api } from './authService';
import { 
  CreateFeeRequest, 
  GetFeesParams, 
  GetFeesResponse, 
  FeeSchema 
} from '@/types/fees/fee-types';

export const createFees = async (fees: CreateFeeRequest[]): Promise<FeeSchema[]> => {
  try {
    const response = await api.post('/admin/fees', { data: fees });
    return response.data;
  } catch (error) {
    console.error('Error creating fees:', error);
    throw error;
  }
};

export const getFees = async (params: GetFeesParams = {}): Promise<GetFeesResponse> => {
  try {
    // Convert params object to URLSearchParams
    const searchParams = new URLSearchParams();
    
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        searchParams.append(key, value as string);
      }
    });

    const response = await api.get(`/admin/fees?${searchParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching fees:', error);
    throw error;
  }
};

export const getFeeById = async (id: string): Promise<FeeSchema> => {
  try {
    const response = await api.get(`/admin/fees/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching fee:', error);
    throw error;
  }
};

export const deleteFee = async (id: string): Promise<void> => {
  try {
    await api.delete(`/admin/fees/${id}`);
  } catch (error) {
    console.error('Error deleting fee:', error);
    throw error;
  }
};

